import React from "react";
import {
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

const ImageUploadForm = ({ images, setImages }) => {
  const MAX_IMAGES = 5;

  // Handle file changes
  const handleFileChange = (index, file) => {
    setImages((prevImages) => {
      const updatedImages = [...prevImages];
      updatedImages[index].file = file;
      return updatedImages;
    });
  };

  // Handle description changes
  const handleDescriptionChange = (index, description) => {
    setImages((prevImages) => {
      const updatedImages = [...prevImages];
      updatedImages[index].description = description;
      return updatedImages;
    });
  };

  // Add a new image field
  const addImageField = () => {
    if (images.length < MAX_IMAGES) {
      setImages((prevImages) => [
        ...prevImages,
        { file: null, description: "" },
      ]);
    }
  };

  // Remove an image field
  const removeImageField = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  return (
    <div>
      {images.map((_, index) => (
        <div
          key={index}
          className="flex justify-between mobileFormWrapper mt-2"
        >
          {/* Image Upload */}
          <div className="w-[45%] mobileInputWrapper">
            <FormItem>
              <FormLabel>Upload Image #{index + 1}*</FormLabel>
              <FormControl className="text-muted pt-2">
                <Input
                  id={`image-${index}`}
                  type="file"
                  onChange={(e) => handleFileChange(index, e.target.files[0])}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          </div>
          {/* Image Description */}
          <div className="w-[45%] mobileInputWrapper">
            <FormItem>
              <FormLabel>Image Description #{index + 1}*</FormLabel>
              <FormControl className="text-muted pt-2">
                <Input
                  id={`description-${index}`}
                  type="text"
                  value={images[index]?.description || ""}
                  placeholder="Write image description"
                  onChange={(e) =>
                    handleDescriptionChange(index, e.target.value)
                  }
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          </div>
          {/* Remove Button */}
          <div className="flex items-end">
            <Button type="button" onClick={() => removeImageField(index)}>
              Remove
            </Button>
          </div>
        </div>
      ))}
      {/* Add Button */}
      {images.length < MAX_IMAGES && (
        <div className="flex justify-end mt-4">
          <Button type="button" onClick={addImageField}>
            + Add Image
          </Button>
        </div>
      )}
    </div>
  );
};

export default ImageUploadForm;
